<template>

  <div>
    <Header />
    <CookieLaw theme="blood-orange"/>
    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header';
import CookieLaw from 'vue-cookie-law';

export default {
  components: {
    Header,
    CookieLaw,
  },
  name: 'app',
};
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100%;
  min-height: 100%;
}
</style>
